import React from 'react';
import { Icon } from './Icon.js';
export const IconAngleFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M5,13h5.164c-.75-2.467-2.698-4.415-5.164-5.165v5.165Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M15.25,16H4.75c-1.517,0-2.75-1.233-2.75-2.75V2.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75V13.25c0,.689,.561,1.25,1.25,1.25H15.25c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconAngleFill18.js.map